export const someTrainsDepartAtTheSameTime = ({ journeys }) => {
  if (journeys.length === 0) return false;
  const departs = journeys.map(({ timing }) => timing.departs);
  return departs.some((timing) => !!timing) && departs.length !== new Set(departs).size;
};
